/**
 * @link https://mui.com/material-ui/react-chip/
 */

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import DoneIcon from '@mui/icons-material/Done';
import DeleteIcon from '@mui/icons-material/Delete';
import {Divider, Typography} from "@mui/material";
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";


export default function FactureeChip() {

  const handleClick = () => {
    alert('You clicked the Chip.');
  };

  const handleDelete = () => {
    alert('You clicked the delete icon.');
  };

  return (
    <>
      <Stack direction="row" spacing={1} sx={{pb: 2}}>
        <Chip label="Chip Filled"/>
        <Chip label="Chip Outlined" variant="outlined"/>
      </Stack>

      <Stack direction="row" spacing={1} sx={{pb: 2}}>
        <Chip label="Clickable" onClick={handleClick}/>
        <Chip label="Clickable" variant="outlined" onClick={handleClick}/>
      </Stack>

      <Stack direction="row" spacing={1} sx={{pb: 2}}>
        <Chip label="Deletable" onDelete={handleDelete}/>
        <Chip label="Deletable" variant="outlined" onDelete={handleDelete}/>
      </Stack>

      <Stack direction="row" spacing={1} sx={{pb: 2}}>
        <Chip
          label="Custom done icon"
          onClick={handleClick}
          onDelete={handleDelete}
          deleteIcon={<DoneIcon/>}
        />
        <Chip
          label="Custom delete icon"
          onClick={handleClick}
          onDelete={handleDelete}
          deleteIcon={<DeleteIcon/>}
          variant="outlined"
        />
      </Stack>

      <Stack direction="row" spacing={1} sx={{pb: 2}}>
        <Chip label="Color: error" color="error"/>
        <Chip label="Color: error" color="error" variant={"outlined"}/>
        <Chip label="Color: warning" color="warning"/>
        <Chip label="Color: warning" color="warning" variant={"outlined"}/>
        <Chip label="Color: success" color="success"/>
        <Chip label="Color: success" color="success" variant={"outlined"}/>
      </Stack>

      <Divider textAlign={"left"}>
        <Typography variant={"h6"}>
          Chip Variants
        </Typography></Divider>

      <Stack direction="row" spacing={1} sx={{mb: 5}}>
        <Chip label="Variant: normal" variant="normal"/>
        <Chip label="Variant: primary" variant="primary"/>
        <Chip label="Variant: secondary" variant="secondary"/>
      </Stack>

      <Divider textAlign={"left"}><Typography variant={"h6"}>
        Facturee Custom Chips (Color mark for Facturee OP Units)
      </Typography></Divider>

      <Stack direction="row" spacing={1} sx={{mb: 5}}>
        <Chip label="Sales" variant="sales"/>
        <Chip label="Purchase" variant="purchase"/>
        <Chip label="Accounting" variant="accounting"/>
        <Chip label="Quality Management" variant="qm"/>
        <Chip label="Packaging" variant="packaging"/>
        <Chip label="Logistics" variant="logistics"/>
      </Stack>
      
      <ShowCode 
        codeString={`function ChipExample() {
  const handleClick = () => {
    alert('You clicked the Chip.');
  };

  const handleDelete = () => {
    alert('You clicked the delete icon.');
  };

  return (
    <>
      {/* Basic Chips */}
      <Stack direction="row" spacing={1} sx={{pb: 2}}>
        <Chip label="Chip Filled" />
        <Chip label="Chip Outlined" variant="outlined" />
      </Stack>

      {/* Interactive Chips */}
      <Stack direction="row" spacing={1} sx={{pb: 2}}>
        <Chip label="Clickable" onClick={handleClick} />
        <Chip label="Clickable" variant="outlined" onClick={handleClick} />
      </Stack>

      <Stack direction="row" spacing={1} sx={{pb: 2}}>
        <Chip label="Deletable" onDelete={handleDelete} />
        <Chip label="Deletable" variant="outlined" onDelete={handleDelete} />
      </Stack>

      {/* Custom Icon Chips */}
      <Stack direction="row" spacing={1} sx={{pb: 2}}>
        <Chip
          label="Custom done icon"
          onClick={handleClick}
          onDelete={handleDelete}
          deleteIcon={<DoneIcon />}
        />
        <Chip
          label="Custom delete icon"
          onClick={handleClick}
          onDelete={handleDelete}
          deleteIcon={<DeleteIcon />}
          variant="outlined"
        />
      </Stack>

      {/* Color Variants */}
      <Stack direction="row" spacing={1} sx={{pb: 2}}>
        <Chip label="Color: error" color="error" />
        <Chip label="Color: error" color="error" variant="outlined" />
        <Chip label="Color: warning" color="warning" />
        <Chip label="Color: warning" color="warning" variant="outlined" />
        <Chip label="Color: success" color="success" />
        <Chip label="Color: success" color="success" variant="outlined" />
      </Stack>

      {/* Chip Variants */}
      <Stack direction="row" spacing={1} sx={{mb: 5}}>
        <Chip label="Variant: normal" variant="normal" />
        <Chip label="Variant: primary" variant="primary" />
        <Chip label="Variant: secondary" variant="secondary" />
      </Stack>

      {/* Facturee Custom Chips */}
      <Stack direction="row" spacing={1} sx={{mb: 5}}>
        <Chip label="Sales" variant="sales" />
        <Chip label="Purchase" variant="purchase" />
        <Chip label="Accounting" variant="accounting" />
        <Chip label="Quality Management" variant="qm" />
        <Chip label="Packaging" variant="packaging" />
        <Chip label="Logistics" variant="logistics" />
      </Stack>
    </>
  );
}`} 
        scope={{ React, Chip, Stack, DeleteIcon, DoneIcon, Typography, Divider }} 
      />
    </>
  );
}
